module.exports = __webpack_public_path__ + "static/track-desktop-bg-eb327340e7dd0f586adf41db45b7c975.png";